<script>
	import { onMount } from "svelte";

	let message = "";
	let textarea;
	let textareaValue = message;
	let canvas;
	let ctx;
	let img;
	let dataImg;
	let imgLoaded = false;
	let showEditor = false;
	let fontsReady = false;
	let badImg = "";
	for (let i = 0; i < 1100; i++){
		badImg += "CBAgQIECAAAE";
	}

	onMount(() => {
		document.fonts.ready.then(() => {
			fontsReady = true;
			refresh();
		});
		ctx = canvas.getContext("2d");
		refresh();
	});

	function refresh() {
		message = decodeURI(window.location.hash?.slice(1)) ?? "";
		textareaValue = message;
		if (ctx && imgLoaded && fontsReady) {
			let lines = message
				.split("\n")
				.filter((line) => line.trim())
				.slice(0, 4);
			let ySpacing = 128;
			let yPos = 520;
			switch (lines.length) {
				case 2:
					yPos = 465;
					break;
				case 3:
					yPos = 384;
					break;
				case 4:
					yPos = 325;
			}
			ctx.font = "120px 'Nanum Pen Script', cursive";
			ctx.textAlign = "center";
			ctx.drawImage(img, 0, 0);
			lines.forEach((line) => {
				ctx.fillText(line, 690, yPos, 600);
				yPos += ySpacing;
			});
			
			if(canvas.toDataURL("image/png").includes(badImg)){
				setTimeout(refresh, 100);
				return;
			} 
			dataImg.src = canvas.toDataURL("image/jpeg");
			// alert(dataImg.src);
			window.scroll(0, 0);
		}
	}

	function revealEditor() {
		textarea.value = "";
		showEditor = true;
		textarea.focus();
	}

	function submit() {
		window.location.hash = encodeURI(textarea.value.trim());
		showEditor = false;
		refresh();
	}

	function imgOnload() {
		imgLoaded = true;
		refresh();
	}

	// $: refresh(message);
	// $: console.log({fontsReady});
</script>

<main style="text-align: center;">
	<img
		bind:this={img}
		on:load={imgOnload}
		alt="Dominican man holding blank whiteboard while making side-eyes."
		src="will.jpg"
		class:hidden={message.trim() != ""}
	/>
	<img
		bind:this={dataImg}
		alt={`Dominican man holding a whiteboard that reads ${message} while making side-eyes.`}
		src="will.jpg"
		class:hidden={message.trim() == ""}
	/>
	<canvas bind:this={canvas} width="1920" height="1080" class="hidden" />
	<br />
	{#if showEditor}
		<textarea bind:this={textarea} bind:value={textareaValue} rows="3" />
		<br />
		<button
			class:hint={textareaValue.trim() != message.trim()}
			title="Submit"
			on:click={submit}>😏</button
		>
	{:else}
		<div
			style="display: inline-block; color: #fff8; cursor: pointer"
			on:click={() => (showEditor = true)}
		>
			Say something else
		</div>
	{/if}
	<div style="font-family: 'Nanum Pen Script'; color: #3a255f">
		Nanum Pen Script
	</div>
</main>

<style>
	main {
		box-sizing: border-box;
		text-align: center;
		/* font-size: 1em; */
		background-color: #3a255f;
		border: 0.5em solid black;
		border-radius: 1em;
		min-height: 85vh;
	}

	img,
	canvas {
		max-width: min(1920px, 95vw);
		max-height: 70vh;
		margin-bottom: 1em;
	}

	textarea {
		background-color: white;
		/* border-radius: 1em; */
		padding: 1em;
		font-size: 1em;
		font-family: sans-serif;
	}

	button {
		all: unset;
		font-size: 3em;
		/* padding: 0.25em; */
		/* margin: 0.5em; */
		color: #333;
		cursor: pointer;
		padding: 0.5em;
		text-shadow: 0 0 0 white;
	}

	.hidden {
		display: none;
	}

	.hint {
		animation: 0.5s linear infinite alternate hint;
	}

	@keyframes hint {
		from {
			text-shadow: 0 0 0 white;
		}

		to {
			text-shadow: 0 0 0.5em white;
		}
	}
</style>
